'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import UILink from 'UIComponents/link/UILink';
import I18n from 'I18n';
import UIApplication from 'UIComponents/app/UIApplication';
import BrowserVersionWrapper from '../BrowserVersionWrapper';
import EnvironmentMismatch from '../EnvironmentMismatch';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { parse as parseQuery } from 'hub-http/helpers/params';
import BetaLoginBanner from '../v2/BetaLoginBanner';

class HubspotApp extends Component {
  componentDidMount() {
    document.title = I18n.text('login.title');
    const {
      search
    } = this.props.location;
    const query = parseQuery(search.substr(1));
    const {
      useDark,
      allowFbSignup
    } = query;

    if (useDark === 'true') {
      const fullPage = document.getElementsByClassName('page')[0];
      fullPage.className += ' dark-bg';
    }

    if (allowFbSignup) {
      const fullPage = document.getElementsByClassName('page')[0];
      fullPage.className += ' fb-crm-signup';
    }
  }

  render() {
    const className = ['/two-factor', '/confirm-to-login'].includes(this.props.location.pathname) ? '' : 'auth-box marketing-box';
    return /*#__PURE__*/_jsxs(UIApplication, {
      name: "LoginUI",
      children: [/*#__PURE__*/_jsx(EnvironmentMismatch, {}), /*#__PURE__*/_jsx(BetaLoginBanner, {}), /*#__PURE__*/_jsx("div", {
        className: className,
        children: /*#__PURE__*/_jsx(BrowserVersionWrapper, {
          children: this.props.children
        })
      }), /*#__PURE__*/_jsxs("footer", {
        className: "copyright",
        children: ["\xA9", new Date().getFullYear(), " HubSpot, Inc.", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.footer.allRightsReserved"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
          href: "https://legal.hubspot.com/privacy-policy",
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.footer.privacy"
          })
        })]
      })]
    });
  }

}

export default HubspotApp;